import React from 'react'

export default function Die(props) {
    const styles= {
        backgroundColor: props.isHeld ? "lightgreen" : "white" 
    }
  return (
    <div className='die-face'
     style={styles}
     onClick={()=>props.funval(props.id)}
     >
      <h2 className='die-num'>{props.value}</h2>
    </div>
  )
}


